import React from 'react';
import PropTypes from 'prop-types';

import {blue500, greyishBlue100} from "assets/jss/main";

JournalEntry.propTypes = {
    title: PropTypes.string,
    date: PropTypes.string,
    type: PropTypes.string
};

function JournalEntry({title, date, type}) {
    const formatDate = (d) => {
        const dateObj = new Date(d);
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const hours = String(dateObj.getHours()).padStart(2, "0");
        const minutes = String(dateObj.getMinutes()).padStart(2, "0");
        return `${day}/${month} ${hours}:${minutes}`;
    };

    return (
        <div style={{
            display: "flex",
            gap: "12px",
            alignItems: "flex-start"
        }}>
            {/* Dot + line */}
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "4px"
            }}>
                <div style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: blue500,
                    flexShrink: 0,
                }}/>
                <div style={{
                    width: "1px",
                    height: "40px",
                    backgroundColor: greyishBlue100,
                    marginTop: "4px"
                }}/>
            </div>

            <div style={{paddingBottom: "24px"}}>
                <div style={{fontSize: "14px", fontWeight: "600", color: "#111827"}}>{title}</div>
                <div style={{fontSize: "13px", color: "#9ca3af", marginTop: "2px"}}>
                    {formatDate(date)} · {type}
                </div>
            </div>
        </div>
    );
}

export default JournalEntry
